export default {"src":"/_next/static/media/tutorials.25f26f20.svg","height":256,"width":362,"blurWidth":0,"blurHeight":0};